import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Rotate16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M3.25 1.00006H1.75V6.25006H7V4.75006H3.87615C5.78971 2.32903 9.51747 2.09281 11.7124 4.28769C13.7626 6.33794 13.7626 9.66206 11.7124 11.7123C9.6621 13.7626 6.33799 13.7626 4.28773 11.7123L3.22707 12.773C5.86311 15.409 10.137 15.409 12.773 12.773C15.4091 10.1369 15.4091 5.86307 12.773 3.22703C10.1446 0.598619 5.88784 0.591012 3.25 3.20421V1.00006Z'
      fill='currentColor'
    />
  </Svg>
);

Rotate16.displayName = 'Rotate16';
export default Rotate16;
